import { openHourType, weekdays, weekdaysType } from '@/@type/booking-sessions';
import { OpenHoursInput, OpenTimeInput } from '@/__generated__/types';
import _ from 'lodash';
import { DeepKeyOf } from '../components/_dashboard/promotion/formik/type';
import { parseTime } from './helperTime';

type SortableValue = string | number | boolean | null | undefined;
type NamedRecord = { name?: string };

export function applySortFilter<T>(array: T[], comparator: (a: T, b: T) => number, query: string): T[] {
    const stabilizedThis = array.map((el, index) => [el, index] as const);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    if (query) {
        const filterName = array.filter((_user) => {
            const name = (_user as NamedRecord).name;
            return typeof name === 'string' && name.toLowerCase().indexOf(query.toLowerCase()) !== -1;
        });
        if (filterName.length > 0) {
            return filterName;
        }
    }
    return stabilizedThis.map((el) => el[0]);
}

const getSortableValue = (item: unknown, key: string): SortableValue => {
    if (typeof item !== 'object' || item === null) return undefined;
    return (item as Record<string, SortableValue>)[key];
};

export function getComparator<T>(order: string, orderBy: string): (a: T, b: T) => number {
    return order === 'desc'
        ? (a: T, b: T): number => descendingComparator(a, b, orderBy)
        : (a: T, b: T): number => -descendingComparator(a, b, orderBy);
}

export function descendingComparator<T>(a: T, b: T, orderBy: string): number {
    const aValue = getSortableValue(a, orderBy);
    const bValue = getSortableValue(b, orderBy);

    if (bValue == null || aValue == null || bValue < aValue) {
        return -1;
    }
    if (bValue > aValue) {
        return 1;
    }
    return 0;
}
export const renderDataOpenTime = (
  dataOpenTime: OpenTimeInput | null | undefined,
  setDayoff: (closeDates: string[]) => void,
  setOpenHours: (openHours: openHourType[]) => void
): void => {
  if (dataOpenTime) {
    if (dataOpenTime.closeDates) {
      setDayoff(dataOpenTime.closeDates.filter((date): date is string => typeof date === 'string'));
    }
    if (dataOpenTime.openHours) {
            const tempOpenHours = dataOpenTime.openHours
                .filter((itemTime): itemTime is OpenHoursInput => Boolean(itemTime))
                .map((itemTime) => {
                    const tempWeekdays = weekdays.map((weekday: weekdaysType) =>
                        itemTime.weekDays.includes(weekday.name)
                            ? { ...weekday, status: true }
                            : { ...weekday, status: false }
                    );

                    return {
                        dateStart: parseTime(itemTime.openStart),
                        dateEnd: parseTime(itemTime.openEnd),
                        openWeekdays: tempWeekdays
                    };
                });

            setOpenHours(tempOpenHours);
        }
    }
};

export const sortList = <T>(list: T[], order: 'asc' | 'desc', orderBy: DeepKeyOf<T>): T[] => {
    const copyList = [...list];
    return _.orderBy(copyList, [orderBy], [order]);
};

export const filterListByKeys = <T>(list: T[], keys: DeepKeyOf<T>[], value: string): T[] => {
    if (keys.length === 0 || value.trim() === '') return list;
    const lowercaseValue = value.toLowerCase();
    const newList = _.filter(list, (item) =>
        _.some(keys, (key) => {
            const fieldValue = _.get(item, key);
            if (fieldValue == null) return false;
            if (typeof fieldValue === 'string') return fieldValue.toLowerCase().includes(lowercaseValue);
            if (typeof fieldValue === 'number') return fieldValue.toString().toLowerCase().includes(lowercaseValue);
            if (typeof fieldValue === 'boolean') return fieldValue.toString().toLowerCase().includes(lowercaseValue);

            return false;
        })
    );
    return newList;
};
